import { arrayToSimpleObj } from '@op/utils';

export const TYPES = [
  {
    name: 'Day-1',
    value: 'days',
    text: 'Day-1',
  },
  {
    name: 'Month-1',
    value: 'months',
    text: 'Month-1',
  },
];

export const DEFAULT_VALUE = {
  value: ['1', '30'],
  type: TYPES[0].value,
};

export const DEFAULT_VALUE_MONTH = {
  value: ['1', '6'],
  type: TYPES[1].value,
};

export const typesTextMap = arrayToSimpleObj(TYPES, 'text', 'value');
